export default {
  'menu.SelfAuditRecordNewPage': '安全自检申请',
};